module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "1000px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      View Travel Form\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "height": "700px",
      "margin-top": "20px"
    }
  }, [_c('v-row', _vm._l((_vm.travelFormData), function(tallyForm, title) {
    return (!_vm.excludeTitles.includes(title) && tallyForm !== null) ? _c('v-col', {
      key: title,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('label', [_vm._v(_vm._s(title))]), _vm._v(" "), (Array.isArray(tallyForm)) ? _c('div', [_vm._v("\n            " + _vm._s(tallyForm.join(', ') || '-') + "\n          ")]) : _c('div', [_vm._v("\n            " + _vm._s(tallyForm || '-') + "\n          ")])]) : _vm._e()
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-759d2863"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/ProfileTally/ViewModalDialog.vue
// module id = 2203
// module chunks = 0